"use client";

import { useState } from "react";
import Link from "next/link";
import { MenuOutlined, CloseOutlined } from "@ant-design/icons";
import FaImage from "../../image/FaImage";
import Image from "next/image";
import { IoSunnyOutline } from "react-icons/io5";
import Cookies from "js-cookie";
import { Drawer, Tag } from "antd";
import AuthDrawer from "../../drawer/AuthDrawer/AuthDrawer";
import { useDispatch, useSelector } from "react-redux";
import { useRouter } from "next/navigation";
import { setUser } from "@/redux/slices/userSlice";
import { openDrawer } from "@/redux/slices/authDrawerSlice";
import CommonImage from "../../image/CommonImage";
import { setTeacher } from "@/redux/slices/teacherSlice";
import TeacherTopNav from "./TeacherTopNav";
import TeacherNotifications from "./TeacherNotifications";
import ThemeToggle from "../../darkMode/ThemeToggle";
import { T_TOKEN_STORE_KEY } from "@/constants/storage";

const menuItems = [
  { key: "home", label: "হোম", href: "/" },
  { key: "courses", label: "কোর্স", href: "/courses/all" },
  { key: "freeExam", label: "ফ্রি এক্সাম", href: "/free-exam" },
  { key: "branches", label: "শাখা সমূহ", href: "/branches" },
  { key: "about", label: "আমাদের সম্পর্কে", href: "/about-us" },
];

export default function TeacherHeader() {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isNotifyOpen, setIsNotifyOpen] = useState(false);
  const [isMenuOpen, setIsMenuOpen] = useState(false);

  const dispatch = useDispatch();
  const router = useRouter();

  const logoutHandler = () => {
    Cookies.remove(T_TOKEN_STORE_KEY);
    dispatch(setTeacher(null));
    router.push("/teacher/login");
  };

  const teacherInfo = useSelector((state) => state.teacher.teacherInfo);
  const setting = useSelector((state) => state.setting.data);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
    setIsNotifyOpen(false);
    setIsMenuOpen(false);
  };

  const toggleNotifyMenu = () => {
    setIsNotifyOpen((prev) => !prev);
    setIsDropdownOpen(false);
    setIsMenuOpen(false);
  };

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
    setIsDropdownOpen(false);
    setIsNotifyOpen(false);
  };

  const [openMenu, setOpenMenu] = useState(null);

  const handleToggleProfile = () => {
    setOpenMenu((prev) => (prev === "profile" ? null : "profile"));
  };

  const handleToggleNotification = () => {
    setOpenMenu((prev) => (prev === "notification" ? null : "notification"));
  };

  return (
    <header className="header bg-white">
      <div className="container">
        <div className="flex items-center justify-between h-16 md:h-20">
          {/* Logo */}
          <Link
            href="/"
            className="flex items-center text-xl font-bold text-[#2e4e8d]"
          >
            <FaImage
              src={
                setting?.logo_light_url ??
                "/images/header-footer/main_logo_light.avif"
              }
              alt={"Mail Logo"}
              className="max-w-[200px] h-[47px]"
              classes="[.dark_&]:hidden inline-block"
            />
            <FaImage
              src={
                setting?.logo_dark_url ??
                "/images/header-footer/main_logo_light.avif"
              }
              alt={"Mail Logo"}
              className="max-w-[200px] h-[47px]"
               classes="hidden [.dark_&]:inline-block"
            />
          </Link>

          {/* Search */}
          <form>
            <div className="search-box">
              <input
                type="text"
                placeholder="কোর্স সার্চ করুন"
                className="search-input hidden sm:inline-block"
              />
              <button type="submit" className="search-button">
                <Image
                  src="/images/header-footer/search.avif"
                  alt="Search Icon"
                  width={20}
                  height={20}
                  className="search-icon"
                  priority
                />
              </button>
            </div>
          </form>

          {/* Desktop Menu */}
          <nav className="hidden xl:flex items-center gap-6">
            {menuItems.map((item) => (
              <Link
                key={item.key}
                href={item.href}
                className="text-primary-text-3 hover:text-primary-text-1 font-medium"
              >
                {item.isTag ? (
                  <Tag color="#E2008D">{item.label}</Tag>
                ) : (
                  item.label
                )}
              </Link>
            ))}
          </nav>

          {/* Right Side */}
          <div className="flex items-center gap-3">
            <ThemeToggle />

            {/* Desktop Buttons */}
            <div className="hidden xl:block">
              <div className="flex items-center gap-4">
                <button className="call-now-btn">
                  {setting && (
                    <Link href={`tel:${setting?.phone_1}`} className="call-now">
                      <div>
                        <Image
                          src="/images/header-footer/call.avif"
                          alt="call Icon"
                          width={20}
                          height={20}
                          className="icon"
                          priority
                        />{" "}
                      </div>
                      কল করুন
                    </Link>
                  )}
                </button>
                <div className="flex items-center gap-3">
                  <div className="flex items-center gap-4">
                    {teacherInfo ? (
                      <>
                        <div className="student-profile-wrap relative">
                          <TeacherNotifications
                            isOpen={openMenu === "notification"}
                            toggleMenu={handleToggleNotification}
                          />
                          <TeacherTopNav
                            isOpen={openMenu === "profile"}
                            toggleMenu={handleToggleProfile}
                            logoutHandler={() => {
                              Cookies.remove(TOKEN_STORE_KEY);
                              dispatch(setTeacher(null));
                              router.push("/teacher/login");
                            }}
                          />
                        </div>
                      </>
                    ) : (
                      <button
                        className="login-reg-btn"
                        onClick={() => router.push("/teacher/login")}
                      >
                        <span className="login-btn">লগ ইন</span>
                        <span className="reg-btn"></span>
                      </button>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          {/* Mobile Buttons */}
          <div className="xl:hidden flex items-center gap-4 relative">
            <button
              className="login-reg-btn"
                        onClick={() => router.push("/teacher/login")}
            >
              <span className="login-btn">লগ ইন</span>
              <span className="reg-btn"></span>
            </button>

            <button
              onClick={toggleMenu}
              className="text-gray-600 hover:text-[#2e4e8d] p-2"
              aria-label="Toggle menu"
            >
              {isMenuOpen ? (
                <CloseOutlined style={{ fontSize: 24 }} />
              ) : (
                <MenuOutlined style={{ fontSize: 24 }} />
              )}
            </button>
          </div>
        </div>
      </div>

      {/* Mobile Notification Dropdown */}
      {isNotifyOpen && (
        <div className="xl:hidden absolute right-4 top-16 z-50 w-64 bg-white rounded shadow-lg p-4">
          <p className="text-gray-700">🔔 আপনার Notifications</p>
          <p className="text-sm text-gray-500">নতুন আপডেট এসেছে!</p>
        </div>
      )}

      {/* Mobile Profile Dropdown */}
      {isDropdownOpen && (
        <div className="xl:hidden absolute right-4 top-16 z-50 w-40 bg-white rounded shadow-lg">
          <Link
            href="/teacher/dashboard"
            className="block px-4 py-2 text-gray-700 hover:bg-gray-100 hover:[.dark_&]:bg-d-oxford-blue"
          >
            ড্যাশবোর্ড
          </Link>
          <button
            onClick={logoutHandler}
            className="block w-full text-left px-4 py-2 text-gray-700 hover:bg-gray-100 hover:[.dark_&]:bg-d-oxford-blue"
          >
            লগ আউট
          </button>
        </div>
      )}

      {/*  Mobile Menu Items */}
      {isMenuOpen && (
        <div className="xl:hidden bg-white border-t border-gray-200">
          <div className="px-4 py-2 space-y-2">
            {menuItems.map((item) => (
              <Link
                key={item.key}
                href={item.href}
                className="block py-2 text-gray-700 hover:text-[#E2008D]"
                onClick={() => setIsMenuOpen(false)}
              >
                {item.label}
              </Link>
            ))}
          </div>
        </div>
      )}
    </header>
  );
}
